import React from 'react';
import { View, ImageBackground, TouchableOpacity } from 'react-native';

import { isString as _isString } from 'lodash';
import PropTypes from 'prop-types';

import { VFButton, VFText, Icon, Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { getThemeImages } from '../../../Themes';
import { isValidPaymentMethodCard } from '../../Utils/Validations';

import {
  paymentCardLoadingConfig,
  shimmerPlaceholderConfig,
} from './PaymentMethodCard.LoadingConfig';
import styles from './PaymentMethodCard.Styles';

function PaymentMethodCard({
  showMakePreferred = false,
  onPressMakePreferred,
  card = {},
  onCardPress,
  isLoading,
  cardTestID,
  makePreferredBtnStyle,
}) {
  const { cardName, lastFourDigits, expiry, nameOnCard } = card;
  const theme = useTheme() || LightThemeColors;
  const Images = getThemeImages();

  if (isLoading) {
    return (
      <Shimmer
        config={paymentCardLoadingConfig}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      />
    );
  }

  if (!isValidPaymentMethodCard(card)) {
    return null;
  }
  return (
    <View style={styles.paymentMethodCardContainer}>
      {_isString(cardName) && (
        <View>
          <VFText style={styles.cardName(theme)} i18nKey={cardName} />
        </View>
      )}

      <TouchableOpacity testID={cardTestID} onPress={onCardPress} style={styles.cardContainer}>
        <ImageBackground
          source={Images.payment_method_card}
          imageStyle={styles.cardBackgroundContainerImageStyle}
          style={styles.cardBackgroundContainer}
        >
          <View style={styles.innerContainer}>
            <Icon source={Images.payment_card_chip} style={styles.cardChip} />

            <Icon source={Images.payment_visa_pay} style={styles.visaPay} />
          </View>

          <VFText style={styles.cardNumber} i18nKey={`****  ****  **** ${lastFourDigits}`} />
          <View style={styles.expiryDate}>
            <VFText style={styles.expiryDateKey} i18nKey="payment_expiry_date" />
            <VFText style={styles.expiryDateValue} i18nKey={expiry} />
          </View>

          {_isString(nameOnCard) && (
            <View style={styles.nameOnCardWrapper}>
              <VFText style={styles.nameOnCard} i18nKey={nameOnCard} />
              {card.icon && <Icon source={Images.payment_visa} style={styles.visaIcon} />}
            </View>
          )}
        </ImageBackground>
      </TouchableOpacity>
      {showMakePreferred && (
        <View style={[styles.makePreferred, makePreferredBtnStyle.parent]}>
          <VFButton
            title="payment_make_payment_method_preferred"
            onPress={() => onPressMakePreferred(card.id)}
            style={[styles.makePreferredBtn, makePreferredBtnStyle.container]}
            textStyle={[styles.makePreferredBtnText, makePreferredBtnStyle.text]}
            testKey={FrameworkTestKeys.MakePreferred}
            type="quaternary"
          />
        </View>
      )}
    </View>
  );
}

PaymentMethodCard.defaultProps = {
  makePreferredBtnStyle: {},
};

PaymentMethodCard.propTypes = {
  isLoading: PropTypes.bool,
  onCardPress: PropTypes.func,
  card: PropTypes.object,
  onPressMakePreferred: PropTypes.func,
  showMakePreferred: PropTypes.bool,
  cardTestID: PropTypes.string,
  makePreferredBtnStyle: PropTypes.shape({
    parent: PropTypes.object,
    container: PropTypes.object,
    text: PropTypes.object,
  }),
};

export default PaymentMethodCard;
